import { NavLink } from 'react-router-dom'
import { useSelector } from 'react-redux'

import { Tooltip } from 'antd'
import styled from 'styled-components'

import { colours, sizes } from '@qflow/theme'

import { SideBar, icons } from 'portal/lib/primitives'
import { useResponsive, useUserProjectRole } from 'portal/lib/hooks'

export function ProjectSettingsSidebarButton({
  accountId,
  projectId,
  projectsTable
}) {
  const { isMobile } = useResponsive()
  const { isProjectAdmin } = useUserProjectRole(accountId, projectId)
  const isCollapsed = useSelector(state => state.ui.data.sidebarCollapsed)

  if (!isProjectAdmin || isMobile) {
    return null
  }

  return isCollapsed ? (
    <Tooltip title="Project Settings" placement="right">
      <StyledNavLink
        id="ProjectSettingsSideBarButton"
        disabled={projectsTable === ''}
        to={projectsTable}
      >
        <icons.Settings size={sizes.MEDIUM} colour="currentColor" />
      </StyledNavLink>
    </Tooltip>
  ) : (
    <SideBar.NavButton
      disabled={projectsTable === ''}
      id="ProjectSettings"
      to={projectsTable}
      Icon={icons.Settings}
      noWrapper={true}
      minimalMargin={true}
    >
      Project Settings
    </SideBar.NavButton>
  )
}

const StyledNavLink = styled(NavLink)`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: transparent;
  border-radius: 6px;
  padding: 8px 8px 8px 10px;
  color: #ffffff;
  opacity: 0.8;

  &:hover:not(.active) {
    opacity: 1;
    color: #ffffff;
  }

  &.active {
    color: ${colours.TEAL};
    background-color: rgba(255, 255, 255, 0.1) !important;
    opacity: 1;
  }
`
